// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs-module__breadcrumbs__nPjrv","item":"breadcrumbs-module__item__Df8hk"};